<template>
    <MainPage :isSideMenu="false" :isMyProfle="true" :isBreadcrumb="false">
        <div>
            <div  v-if="isInit" class="flashsale-page">
                <div class="bds-flashsale">
                    <div class="wrapper-flashsale">
                        <div class="flashsale-logo">
                            <img src="../../../assets/new/icon/ic-flash-sale@3x.png" />
                        </div>
                        <div class="flashsale-time d-flex">
                            <div class="time-label">{{lbl.B2B.home.ends_in}}</div>
                            <div class="time-block">{{getTimerSplit().day}}</div>
                            <div class="time-item">:</div>
                            <div class="time-block">{{getTimerSplit().hour}}</div>
                            <div class="time-item">:</div>
                            <div class="time-block">{{getTimerSplit().minute}}</div>
                            <div class="time-item">:</div>
                            <div class="time-block">{{getTimerSplit().second}}</div>
                        </div>
                    </div>
                </div>
                <div class="topbar-flashsale-m">
                    <div class="wrapper d-flex">
                        <div class="left no-center d-flex">
                            <div class="logo">
                                <img class="btn-back" @click="clickBack()" src="../../../assets/new/icon/btn-back.svg" />
                                <img class="flashsale-img" src="../../../assets/new/icon/Flash sale 1@3x.png" />
                            </div>
                        </div>
                        <div class="right no-center d-flex">
                            <div class="wrapper-flashsale-time d-flex">
                                <div class="time-label">{{lbl.B2B.home.ends_in}}</div>
                                <div class="time-block">{{getTimerSplit().day}}</div>
                                <div class="time-block">{{getTimerSplit().hour}}</div>
                                <div class="time-block">{{getTimerSplit().minute}}</div>
                                <div class="time-block">{{getTimerSplit().second}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="Campaign-List">
                    <FlashsaleList
                        v-if="isInitCampaignConfig"
                        ref="campaign-list"
                        :lbl="lbl"
                        :initListConfig="campaignListConfig"
                        :initFilterConfig="campaginListFilterConfig"
                        :busEvent="busCampaign"
                        :isLoading="isLoaded"
                        @campaignsFlashSale="campaings($event)"
                        @clickAddToCart="clickAddToCart($event)"
                    ></FlashsaleList>
                </div>
            </div>
            <ModalMaster :controller="modalController"/>
        </div>
    </MainPage>
</template>

<script>
import Vue from "vue";
//helper
import Account from "@/helper/AccountHelper.js";
import Locale from "@/helper/locale/Locale.js";
import TimerHelper from "@/helper/TimerHelper.js";
import DatetimeHelper from "@/helper/DatetimeHelper.js";
import FlashSaleHelper from "../../../helper/FlashSaleHelper.js";
//mixin
import AccountMixin from '@/mixin/AccountMixin.js';
import ErrorApiMixin from '@/mixin/ErrorApiMixin.js';
import LocaleMixin from '@/mixin/LocaleMixin.js';
import ModalMixin from '@/mixin/ModalMixin.js';
//service
import {
    CampaignListConfigBuilder,
    CampaignListFilterConfigBuilder
} from "@/service/config/CampaignConfigModel.js";
//component
import MainPage from "@/components/Layout/Page/MainPage.vue";
import FlashsaleList from "../component/FlashsaleList.vue";
//modal
import ModalMaster from "@/components/Modal/ModalMaster.vue";
import ModalFactory from "@/components/Modal/ModalFactory";
//core
import BzbsCart from "@/service/BzbsCart.js";
import AddCartModel from "@/model/CartModel.js";
export default {
    name: "Flashsale",
    mixins: [AccountMixin, ErrorApiMixin, LocaleMixin, ModalMixin],
    components: {
        ModalMaster,
        MainPage,
        FlashsaleList
    },
    data: function() {
        return {
            lbl: Locale.getLbl(),
            lblCode: Locale.getLocaleCode(),
            modalFactory: new ModalFactory(),
            modalController: null,
            isScrollFirsttime: false,

            campaignListConfig: {},
            campaginListFilterConfig: {},

            isInit: false,
            isInitCampaignConfig: false,
            isFlashSale: true,
            isLoaded: false,

            isInitflashsaleConfig: false,
            flashsaleListConfig: {},
            flashsaleListFilterConfig: {},
            isLoadedFlashSale: false,

            busCampaign: new Vue(),
            busTopbar: new Vue(),
            campaigns: [],
            timer: new TimerHelper(),
            isShowFlashSale: false,
        };
    },
    created: function() {
        this.query = Account.getCacheQuery("DealShop")
        this.blobConfig = Account.getCacheBlob("BlobConfig")
        this.cartConfig = Account.getCacheCart()
        this.initialModal();
        this.initialFlashSaleSeemore();
        this.initialLoadMore();
        this.isInit = true;
    },
    mounted: function() {
    },
    beforeDestroy: function() {
        window.onscroll = null;
    },
    methods: {
        initialModal: function () {
            this.alertModal = this.modalFactory.getAlertModal();
            this.loadingModal = this.modalFactory.getLoadingModal();
            this.addToCartModal = this.modalFactory.getAddToCartModal();
            this.modalController = this.modalFactory.getModalController();
        },
        initialFlashsale: function () {
            this.flashsaleListConfig = {};
            this.flashsaleListFilterConfig = {};

            var listConfig = new CampaignListConfigBuilder()
                .setConfigList(this.blobConfig.flash_sale_campaign_list_config)
                .setSeeMore(false);

            this.flashsaleListConfig = listConfig.create();

            var filterConfig = new CampaignListFilterConfigBuilder();
            this.flashsaleListFilterConfig = filterConfig.create();

            this.isInitflashsaleConfig = true;
        },
        initialFlashSaleSeemore: function () {
            this.campaignListConfig = {};
            this.campaginListFilterConfig = {};

            var listConfig = new CampaignListConfigBuilder()
                .setConfigList(this.blobConfig.flash_sale_campaign_list_config)
                .setSeeMore(false);

            this.campaignListConfig = listConfig.create();

            var filterConfig = new CampaignListFilterConfigBuilder();
            this.campaginListFilterConfig = filterConfig.create();



            this.isInitCampaignConfig = true;

            this.busCampaign.$emit('reInitList', {
                listConfig: this.campaignListConfig,
                filterConfig: this.campaginListFilterConfig,
                isFlashSale: this.isFlashSale
            });
        },
        initialLoadMore: function() {
            window.onscroll = () => {
                // 100 คือระยะก่อนถึงจุดล่างสุดของ page
                var scrollOffSet = 100;
                var pageHeight = Math.max(
                    window.pageYOffset,
                    document.documentElement.scrollTop,
                    document.body.scrollTop
                );
                var bottomOfWindow =
                    pageHeight + window.innerHeight >
                    document.documentElement.offsetHeight - scrollOffSet;
                if (bottomOfWindow) {
                    this.$refs['campaign-list'].loadMore();
                }
            };
        },
        campaings: function(campaigns) {
            this.campaigns = campaigns
            this.setFlashSaleTime()
        },
        setFlashSaleTime: function () {
            if (this.campaigns != null && this.campaigns.length > 0) {
                let campaign = this.campaigns[0];
                let current = DatetimeHelper.getCurrentTimeTimezoneThai();
                let expDate = campaign.expireDate;
                if (current < expDate) {
                    this.isShowFlashSale = true;
                    this.runTimer(campaign);
                } else {
                    this.isShowFlashSale = false;
                }
            } else {
                return ;
            }

        },
        runTimer: function(campaign) {
            let current = DatetimeHelper.getCurrentTimeTimezoneThai();
            let expDate = campaign.expireDate;
            let expireIn = expDate - current;

            this.timer.initialTimer(expireIn, ' : ', true, true,true);
            this.timer.runTimer(() => {
                this.isShowFlashSale = false;
                this.flashsaleExpire();
            });
        },
        flashsaleExpire: function() {
            this.modalController.alertModal.clearModal()
                                       .setMsg(this.lbl.bzbdealshop.flashsale.expire)
                                       .setBlobConfig(this.blobConfig)
                                       .setBtnOk(this.lbl.bzbdealshop.flashsale.close)
                                       .show();
            this.modalController.alertModal.onClickOk(()=>{
                this.$router.push('/')
            });
        },
        getTimerSplit: function() {
            return FlashSaleHelper.getTimerSplit(this.timer);
        },
        clickBack: function() {
            if (this.query.target_page == "flashsale") {
                window.location.replace(this.query.returnUrl);
            } else {
                this.$router.back();
            }
            //this.$router.back()
        },
        addToCartApi: async function(item) {
            return new Promise((resolve, reject)  => {
                var strBzbsToken = Account.getToken();
                var cartItem = new AddCartModel();
                cartItem.addItem(item.campaignId, item.qty);
                var cartParams =  cartItem.getParams();
                this.loadingModal.show();
                BzbsCart.apiAddToCart(strBzbsToken, cartParams,this.cartConfig.shoppingcart_api).then((result) => {
                    this.loadingModal.hide();
                    console.log(result);
                    this.addToCartModal.show();
                    setTimeout(() =>{
                        this.addToCartModal.hide();
                    }, 2000);
                    resolve(true);
                }).catch((error) => {
                    console.log(error)
                    this.loadingModal.hide();
                    if  (error.response){
                        var err = error.response.data.error;
                        this.alertModal
                                .setMsg(err.message)
                                .show();
                    }
                    reject(false);
                });
            });
        },
        clickAddToCart: async function(item) {
            var resAddToCart = await this.addToCartApi(item);
            if (resAddToCart) {
                console.log("success");
            }
        },
    }
}
</script>

<style lang="scss" scoped>
    @import "@/style/base/base.scss";
    @import "./Flashsale.scss";
</style>
